import { render, staticRenderFns } from "./PreviewTab.vue?vue&type=template&id=6d0c52ae"
import script from "./PreviewTab.vue?vue&type=script&lang=js"
export * from "./PreviewTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports